import { gql } from '@apollo/client'

export const FRAGMENT_SOA_CATEGORY = gql`
  fragment FragmentSoaCategory on CategorySOA {
    id
    country
    name
  }
`
